import { atom } from 'jotai'
import { Entity } from '../api/Models'

// Create your atoms and derivatives
export const apiResultAtom = atom<Entity | null>(null)
export const refreshProfile = atom<boolean>(false)
